import { get, post } from './../Config/config';

export const RecycleAPI = {
    get: (data) => get(`/deleted/leads`, { params: data }),
    restore: (data) => post('/lead/action/restore', data),
    DeleteNote: (data) => post('/lead/delete-note', data),

} 